
import {
  defineComponent,
  PropType
} from 'vue';

import {
  GithubPullRequest
} from '../types/GithubData'

import Repo from './Repo.vue';
import BorderSection from './BorderSection.vue';

export default defineComponent({
  name: 'MyRepos',
  components: { Repo, BorderSection },
  props: {
    header: String,
    repos: {
      type: Array as PropType<Array<GithubPullRequest>>,
      default: () => []
    },
    reposToPulls: {
      type: Object as PropType<{ [key: string]: GithubPullRequest[]; }>,
      default: () => ({})
    }
  },
});
